const BASE = "/static/images";

export const buildings = [
  {
    slug: "goswell-road",
    name: "Goswell Road",
    area: "Angel / Islington",
    address: "338-346 Goswell Road, London, EC1V 7LQ",
    isNew: true,
    capacity: "11 units",
    sizeRange: "590sqft – 7,534sqft",
    priceFrom: "From £4,000/pcm",
    shortDescription: "338 Goswell Road is a characterful former Art-Deco warehouse turned modern workspace, right in the heart of Angel. A great option for creative teams looking for a central London base with plenty of personality.",
    longDescription: "Set on one of Islington's best-known streets, 338 Goswell Road blends industrial heritage with contemporary design. Originally a tobacco warehouse, the generous proportions, high ceilings and large windows flood the spaces with natural light. Studios and offices have been thoughtfully refurbished, offering flexible layouts that work just as well for small teams as they do for growing businesses. Step outside and you're straight into Angel — independent cafés, bakeries, bars, restaurants and canal walks, all on your doorstep. Angel Underground is just a few minutes away.",
    specification: ["High ceilings", "Natural daylight", "Flexible layouts"],
    transport: {
      underground: [{ name: "Angel Station (Northern Line)", detail: "4–6 min walk" }],
      mainline: [
        { name: "Farringdon Station (Thameslink & National Rail)", detail: "15–20 min walk" },
        { name: "Barbican Station (Circle, Hammersmith & City, Metropolitan)", detail: "12–15 min walk" },
      ],
      amenities: [
        { name: "Cafés, bakeries and lunch spots", detail: "Throughout Angel & Upper Street" },
        { name: "Restaurants and bars", detail: "For team lunches or after-work drinks" },
        { name: "Supermarkets and local shops", detail: "Within walking distance" },
        { name: "Green spaces and canal walks", detail: "Nearby for breaks and downtime" },
      ],
    },
    heroImageUrl: `${BASE}/AS_GOSWELL_ROAD_4x5.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "cannon-wharf",
    name: "Cannon Wharf",
    area: "Surrey Quays",
    address: "Pell Street, London, SE8 5EN",
    isNew: true,
    capacity: "57 units",
    sizeRange: "221sqft – 2,021sqft",
    priceFrom: "From £744/pcm",
    shortDescription: "Cannon Wharf is a bright, modern workspace set along the river in Surrey Quays. Great for teams who want more space, natural light and a calmer setting without feeling cut off from London.",
    longDescription: "Set on the edge of Greenland Dock, Cannon Wharf offers a relaxed riverside working environment with contemporary offices and studios. Large windows, open layouts and plenty of natural light throughout. Professional enough for client meetings and growing teams, but laid-back enough to avoid the corporate feel of more central locations. Especially well suited to creative companies and tech teams. Great links into Canary Wharf, London Bridge and the City.",
    specification: ["Natural daylight", "Large windows", "Open layouts"],
    transport: {
      underground: [{ name: "Canada Water Station (Jubilee Line)", detail: "Around 18–20 min walk (or a short bus ride)" }],
      mainline: [
        { name: "Surrey Quays Station (London Overground)", detail: "8–12 min walk" },
        { name: "South Bermondsey Station (National Rail)", detail: "20–25 min walk" },
      ],
      amenities: [
        { name: "Riverside cafés and pubs", detail: "Around Greenland Dock" },
        { name: "Local lunch spots, coffee shops and bakeries", detail: "Nearby" },
        { name: "Supermarkets and everyday shops", detail: "Within walking distance" },
        { name: "Cycle routes", detail: "Quieter commute compared to central London" },
      ],
    },
    heroImageUrl: `${BASE}/AS_CANNON_WHARF.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "the-mille",
    name: "The Mille",
    area: "Brentford",
    address: "1000 Great West Road, Brentford, TW8 9DW",
    isNew: true,
    capacity: "42 units",
    sizeRange: "250sqft – 6,000sqft",
    priceFrom: "From £900/pcm",
    shortDescription: "The Mille is a new landmark workspace on Brentford's Golden Mile. Set within a striking glass-fronted building, it combines light-filled workspaces with excellent transport links.",
    longDescription: "The Mille offers contemporary design with practical flexibility on Great West Road. Studios and workspace units are ideal for creative businesses, production teams and small enterprises. Strong links to central transport routes and local amenities. The Mille supports both established businesses and those looking for adaptable workspace in West London.",
    specification: ["Natural daylight throughout", "Flexible workspace formats", "High-speed broadband", "On-site parking (subject to availability)", "Secure entry and 24/7 access"],
    transport: {
      underground: [{ name: "Boston Manor Station (Piccadilly Line)", detail: "10–12 min walk" }],
      mainline: [
        { name: "Brentford Station", detail: "4–6 min walk" },
        { name: "Kew Bridge Station", detail: "10–15 min walk" },
      ],
      amenities: [
        { name: "Sainsbury's & local shops", detail: "Short walk away" },
        { name: "Cafés, eateries and everyday services", detail: "Close by" },
        { name: "Heathrow, A4/A316 and M4", detail: "Easy access for broader travel and logistics" },
      ],
    },
    heroImageUrl: `${BASE}/AS_THE_MILLE.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "platform-studios-west",
    name: "Platform Studios (West)",
    area: "Hackney Central",
    address: "Morning Lane, London, E9 6ND",
    isNew: true,
    capacity: "27 Studios",
    sizeRange: "80sqft – 3,000sqft",
    priceFrom: "From £685/pcm",
    shortDescription: "Platform Studios (West) offers flexible studios within the former Nike outlet building — now transformed into bright, modern workspaces for artists, designers, makers, and creative businesses.",
    longDescription: "Studios range from 80–3,000 sq ft, featuring high ceilings, excellent natural light, and select air-conditioned units. Just a 6-minute walk from Hackney Central and Hackney Downs Overground, Platform Studios (West) combines industrial character with contemporary finishes in one of East London's most vibrant creative districts.",
    specification: ["Excellent natural daylight", "Elevator", "High ceilings", "Air conditioning (on select units)"],
    transport: {
      underground: [
        { name: "Bethnal Green Station", detail: "1.3 miles (26 min walk)" },
        { name: "Stratford Station", detail: "2.1 miles (42 min walk)" },
      ],
      mainline: [
        { name: "Hackney Central Station", detail: "0.3 miles (6 min walk)" },
        { name: "London Fields Station", detail: "0.5 miles (10 min walk)" },
      ],
      amenities: [
        { name: "London Fields Park", detail: "0.7 miles (14 min walk)" },
        { name: "The Pembury Tavern", detail: "0.8 miles (16 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/platform-studios-west-hero.webp`,
    galleryImageUrls: [],
  },
  // {
  //   slug: "oxgate-house",
  //   name: "Oxgate House",
  //   area: "Brent Cross",
  //   address: "Oxgate Lane, London, NW2 7FT",
  //   isNew: false,
  //   capacity: "190 Studios",
  //   sizeRange: "70sqft – 5,500sqft",
  //   priceFrom: "From £165/pcm",
  //   shortDescription: "Opened in July 2020, Oxgate House is a former cigarette factory converted in three phases and our biggest location. Studio spaces range from 5 to 80m² with natural light and ultra-fast Wi-Fi.",
  //   longDescription: "A diverse and varied community, from small e-commerce businesses and production kitchens to fine artists, independent designers and content creators. Onsite parking, outdoor communal areas and a busy atmosphere. Situated just off the Edgware Road, a stone's throw from Brent Cross.",
  //   specification: ["Natural daylight", "Elevator", "Off street parking", "Entryphone system", "High speed Wi-Fi", "CCTV"],
  //   transport: {
  //     underground: [
  //       { name: "Dollis Hill Station (Jubilee Line)", detail: "0.7 miles (14 min walk)" },
  //       { name: "Brent Cross Station (Northern Line)", detail: "1.1 miles (22 min walk)" },
  //     ],
  //     mainline: [
  //       { name: "Brent Cross West", detail: "0.9 miles (18 min walk)" },
  //       { name: "Cricklewood Station", detail: "1.4 miles (28 min walk)" },
  //     ],
  //     amenities: [
  //       { name: "Tesco Express", detail: "0.8 miles (16 min walk)" },
  //       { name: "Sainsbury's", detail: "1.1 miles (22 min walk)" },
  //       { name: "The Ox & Gate Pub", detail: "0.4 miles (8 min walk)" },
  //     ],
  //   },
  //   heroImageUrl: `${BASE}/Photo-06-06-2023-12-34-08-skyreplacement.webp`,
  //   galleryImageUrls: [],
  // },
  {
    slug: "wallis-house",
    name: "Wallis House",
    area: "Brentford",
    address: "1100 Great West Rd, Brentford, TW8 0HE",
    isNew: false,
    capacity: "56 Studios",
    sizeRange: "35sqft – 1,800sqft",
    priceFrom: "From £150/pcm",
    shortDescription: "Grade II Listed Art Deco building built in the late 1930s, designed by Wallis Gilbert and Partners — one of the last original buildings on Brentford's Golden Mile.",
    longDescription: "Newly fitted units benefit from great natural light with extensive glazing. The majority of units offer 3.4m floor-to-ceiling height. Super-fast fibre Wi-Fi as standard and complimentary underground parking upon request.",
    specification: ["Natural daylight", "High ceilings", "Off street parking", "High speed Wi-Fi", "Entryphone system", "CCTV"],
    transport: {
      underground: [
        { name: "South Ealing Station (Piccadilly Line)", detail: "1.2 miles (24 min walk)" },
        { name: "Gunnersbury Station (District Line)", detail: "1.1 miles (21 min walk)" },
      ],
      mainline: [
        { name: "Brentford Rail Station", detail: "0.5 miles (10 min walk)" },
        { name: "Kew Bridge Rail Station", detail: "0.6 miles (12 min walk)" },
      ],
      amenities: [
        { name: "Morrisons", detail: "0.6 miles (12 min walk)" },
        { name: "Costa Coffee", detail: "0.7 miles (14 min walk)" },
        { name: "Heathrow Airport", detail: "8 miles (20 min drive)" },
      ],
    },
    heroImageUrl: `${BASE}/wallis-house-hero.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "stone-studios",
    name: "Stone Studios",
    area: "Hackney Wick",
    address: "80-84 Wallis Rd, London, E9 5TB",
    isNew: false,
    capacity: "30 Studios",
    sizeRange: "92sqft – 925sqft",
    priceFrom: "From £145/pcm",
    shortDescription: "Launched September 2024, Stone Studios is the newest addition to Hackney Wick's thriving creative scene. Modern development with cutting-edge workspaces designed for flexibility.",
    longDescription: "From studios to larger open-plan units, Stone Studios caters to businesses seeking a dynamic and contemporary environment. Excellent transport links and location in one of London's most vibrant creative areas.",
    specification: ["Excellent natural light", "24/7 access with CCTV", "Brand new fit out", "High ceilings throughout"],
    transport: {
      underground: [
        { name: "Pudding Mill Lane DLR Station", detail: "1.0 miles (20 min walk)" },
        { name: "Bow Road Underground Station", detail: "1.4 miles (28 min walk)" },
      ],
      mainline: [
        { name: "Hackney Wick Station", detail: "0.1 miles (2 min walk)" },
        { name: "Stratford International Station", detail: "1.5 miles (30 min walk)" },
      ],
      amenities: [
        { name: "Queen Elizabeth Olympic Park", detail: "0.5 miles (10 min walk)" },
        { name: "Victoria Park", detail: "0.7 miles (14 min walk)" },
        { name: "Crate Brewery", detail: "0.2 miles (4 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/stone-studios-edited.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "paynes-wharf",
    name: "Paynes Wharf",
    area: "Deptford",
    address: "25 Wharf St, London, SE8 3GG",
    isNew: false,
    capacity: "60 Studios",
    sizeRange: "81sqft – 2,500sqft",
    priceFrom: "From £335/pcm",
    shortDescription: "Open since March 2023, Paynes Wharf is our first riverside complex in Deptford — a 10 minute walk along the river from Cutty Sark. All units have exceptional natural light, lift access, and super-fast Wi-Fi.",
    longDescription: "Just around the corner you can find the thriving high street of Deptford with its cafés, bars and restaurants. Situated along the Thames in Deptford, offering a stunning riverside location with rich maritime history.",
    specification: ["Natural daylight", "Elevator", "High speed Wi-Fi", "CCTV", "Entryphone system"],
    transport: {
      underground: [
        { name: "Cutty Sark DLR Station", detail: "0.8 miles (16 min walk)" },
        { name: "New Cross Station", detail: "1.0 mile (20 min walk)" },
      ],
      mainline: [
        { name: "Deptford Station", detail: "0.5 miles (10 min walk)" },
        { name: "Greenwich Station", detail: "0.7 miles (14 min walk)" },
      ],
      amenities: [
        { name: "Greenwich Park", detail: "0.9 miles (18 min walk)" },
        { name: "Deptford Market Yard", detail: "0.6 miles (12 min walk)" },
        { name: "The Dog & Bell Pub", detail: "0.3 miles (6 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/paynes-wharf-hero.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "q-west",
    name: "Q West",
    area: "Brentford",
    address: "1100 Great West Road, Brentford, TW8 0GP",
    isNew: true,
    capacity: "93 units",
    sizeRange: "150sqft – 2,639sqft",
    priceFrom: "From £400/pcm",
    shortDescription: "Q West is a modern workspace hub in the heart of Brentford with excellent transport links, a mix of small to large units, and on-site parking.",
    longDescription: "Studios at Q West feature clean, modern interiors with high ceilings and natural light. Most units are self-contained and connected to high-speed fibre broadband. Lift access, 24/7 entry, and on-site management. Secure parking available on request.",
    specification: ["Natural daylight", "Lift access", "On-site parking", "High speed Wi-Fi", "Secure entry system", "24/7 access"],
    transport: {
      underground: [
        { name: "South Ealing Station (Piccadilly Line)", detail: "0.9 miles (19 min walk)" },
        { name: "Northfields Station (Piccadilly Line)", detail: "1.1 miles (23 min walk)" },
      ],
      mainline: [
        { name: "Brentford Station", detail: "0.6 miles (13 min walk)" },
        { name: "Kew Bridge Station", detail: "0.7 miles (15 min walk)" },
      ],
      amenities: [
        { name: "Sainsbury's", detail: "0.2 miles (4 min walk)" },
        { name: "Rada Coffee & Eatery", detail: "0.1 miles (3 min walk)" },
        { name: "Heathrow Airport", detail: "7 miles (20 min drive)" },
      ],
    },
    heroImageUrl: `${BASE}/QWest-Cover.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "anerley-works",
    name: "Anerley Works",
    area: "Crystal Palace",
    address: "183A Anerley Rd, London, SE20 8EF",
    isNew: false,
    capacity: "46 Studios",
    sizeRange: "100sqft – 1,300sqft",
    priceFrom: "From £350/pcm",
    shortDescription: "Situated in the heart of Crystal Palace, Anerley Works is the former Crystal Palace Bowls Club transformed into an exciting creative hub.",
    longDescription: "Rich history and a wide variety of amenities, from green spaces to trendy cafés and boutiques, providing a vibrant yet relaxed atmosphere in this otherwise sleepy area of South London.",
    specification: ["Natural daylight", "High speed Wi-Fi"],
    transport: {
      underground: [
        { name: "Penge West Station (Overground)", detail: "0.5 miles (10 min walk)" },
        { name: "Crystal Palace Station (Overground)", detail: "0.6 miles (12 min walk)" },
      ],
      mainline: [
        { name: "Anerley Rail Station", detail: "0.2 miles (4 min walk)" },
        { name: "Crystal Palace Rail Station", detail: "0.6 miles (12 min walk)" },
      ],
      amenities: [
        { name: "Tesco Express", detail: "0.3 miles (6 min walk)" },
        { name: "Crystal Palace Park", detail: "0.6 miles (12 min walk)" },
        { name: "Sainsbury's", detail: "0.7 miles (14 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/anerley-works-south-london-studio-spaces.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "standard-road",
    name: "Standard Road",
    area: "North Acton",
    address: "52-56 Standard Rd, London, NW10 6EU",
    isNew: false,
    capacity: "76 Studios",
    sizeRange: "95sqft – 3,700sqft",
    priceFrom: "From £305/pcm",
    shortDescription: "Standard Road is our first site in North West London. 76 studios split between two floors with an onsite café opportunity at the entrance and retail-style units with street-facing entrances.",
    longDescription: "Secure gated parking managed by PCM. High-speed Wi-Fi throughout. Typical uses range from small crafts, tech start-ups, administration to larger-scale operations.",
    specification: ["Natural daylight", "High speed Wi-Fi", "Café space", "Off street parking", "CCTV"],
    transport: {
      underground: [
        { name: "Acton Main Line", detail: "0.8 miles (15 min walk)" },
        { name: "Harlesden", detail: "0.9 miles (18 min walk)" },
      ],
      mainline: [
        { name: "North Acton", detail: "0.4 miles (8 min walk)" },
        { name: "East Acton", detail: "0.6 miles (12 min walk)" },
      ],
      amenities: [
        { name: "Wormwood Scrubs Park", detail: "1.3 miles (26 min walk)" },
        { name: "Asda Park Royal Superstore", detail: "1.0 mile (20 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/standard-road-north-west-london-studio-spaces.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "cobbold-works",
    name: "Cobbold Works",
    area: "Willesden",
    address: "Cobbold Rd, London, NW10 9ST",
    isNew: false,
    capacity: "26 Studios",
    sizeRange: "100sqft – 500sqft",
    priceFrom: "From £295/pcm",
    shortDescription: "Cobbold Works offers a distinctive blend of history and modern functionality in the heart of Willesden. A fully secured, gated facility with high-spec finishes.",
    longDescription: "Ideal for small craft businesses, tech start-ups, or larger-scale operations. Flexible unit sizes and a vibrant atmosphere in a creative and dynamic community.",
    specification: ["Excellent natural daylight", "High ceilings", "Double glazing", "Super fast Wi-Fi"],
    transport: {
      underground: [
        { name: "Harlesden Station", detail: "1.2 miles (24 min walk)" },
        { name: "Willesden Green Station", detail: "1.0 mile (20 min walk)" },
      ],
      mainline: [
        { name: "Dollis Hill Station", detail: "0.4 miles (8 min walk)" },
        { name: "Neasden Station", detail: "0.5 miles (10 min walk)" },
      ],
      amenities: [
        { name: "Roundwood Park", detail: "0.2 miles (4 min walk)" },
        { name: "The Burren London Hotel", detail: "0.3 miles (6 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/cobbold-works-north-west-london-studio-spaces.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "highbury-studios",
    name: "Highbury Studios",
    area: "Highbury",
    address: "2 Melody Ln, London, N5 2BQ",
    isNew: false,
    capacity: "6 Studios",
    sizeRange: "68sqft – 210sqft",
    priceFrom: "From £385/pcm",
    shortDescription: "Highbury Studios provides a modern and functional space in the bustling area of Highbury. Clean, adaptable interiors perfect for businesses looking for a versatile workspace in North London.",
    longDescription: "Whether in creative industries, tech, or any other field, Highbury Studios caters to a variety of needs. Strategic location with contemporary facilities makes it a prime choice for professionals seeking an inspiring and convenient workspace.",
    specification: ["High-speed Wi-Fi", "Natural Daylight", "24/7 Access", "Parking Spaces"],
    transport: {
      underground: [
        { name: "Arsenal Station (Piccadilly Line)", detail: "0.6 miles (12 min walk)" },
        { name: "Caledonian Road Station (Piccadilly Line)", detail: "0.7 miles (14 min walk)" },
      ],
      mainline: [
        { name: "Highbury & Islington Station", detail: "0.5 miles (10 min walk)" },
        { name: "Drayton Park Station", detail: "0.4 miles (8 min walk)" },
      ],
      amenities: [
        { name: "Highbury Fields", detail: "0.5 miles (10 min walk)" },
        { name: "Tesco Express", detail: "0.3 miles (6 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/highbury-studios-north-london-studios-spaces.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "monier-works",
    name: "Monier Works",
    area: "Hackney Wick",
    address: "2 Casings Way, London, E3 2TH",
    isNew: false,
    capacity: "45 Studios",
    sizeRange: "80sqft – 1,600sqft",
    priceFrom: "From £295/pcm",
    shortDescription: "Opened in 2022 in the heart of Fish Island, Hackney Wick. 45 studios with high ceilings and East-facing natural light. Superfast Wi-Fi, passenger lift, communal tea points.",
    longDescription: "Two retail units on the ground floor suitable for a café, restaurant, wellness or gallery space. Secure bike storage within the building. Located in Hackney Wick, renowned for its creative spirit, surrounded by trendy cafés, galleries, and the scenic River Lea.",
    specification: ["Natural daylight", "Elevator", "High speed Wi-Fi"],
    transport: {
      underground: [
        { name: "Pudding Mill Lane DLR Station", detail: "1.0 miles (20 min walk)" },
        { name: "Bow Road Underground Station", detail: "1.4 miles (28 min walk)" },
      ],
      mainline: [
        { name: "Hackney Wick Station", detail: "0.3 miles (6 min walk)" },
        { name: "Stratford International Station", detail: "1.2 miles (24 min walk)" },
      ],
      amenities: [
        { name: "Victoria Park", detail: "0.6 miles (12 min walk)" },
        { name: "Crate Brewery", detail: "0.3 miles (6 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/monier-works-hero.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "action-house",
    name: "Action House",
    area: "Old Kent Road",
    address: "53 Sandgate St, London, SE15 1LE",
    isNew: false,
    capacity: "51 Studios",
    sizeRange: "70sqft – 1,000sqft",
    priceFrom: "From £365/pcm",
    shortDescription: "Situated within a gated yard just to the east of the Old Kent Road. Completed in 2017 with the latest in 5G Wi-Fi. Onsite café for breakout space.",
    longDescription: "Typical use ranges from small crafts to tech start-ups and administration. Located on Old Kent Road, a rapidly developing area of South East London with excellent transport links.",
    specification: ["Natural daylight", "High speed Wi-Fi", "Off street parking", "Café", "Entryphone system", "CCTV"],
    transport: {
      underground: [
        { name: "Nunhead Station", detail: "1.0 mile (20 min walk)" },
        { name: "Denmark Hill Station", detail: "1.1 miles (22 min walk)" },
      ],
      mainline: [
        { name: "Peckham Rye Station", detail: "0.5 miles (10 min walk)" },
        { name: "Queens Road Peckham Station", detail: "0.8 miles (16 min walk)" },
      ],
      amenities: [
        { name: "Peckham Rye Park", detail: "0.6 miles (12 min walk)" },
        { name: "Peckham Levels", detail: "0.3 miles (6 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/action-house.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "warwick-works",
    name: "Warwick Works",
    area: "Hackney Downs",
    address: "Downs Rd, Lower Clapton, London, E5 8QJ",
    isNew: false,
    capacity: "23 Studios",
    sizeRange: "100sqft – 750sqft",
    priceFrom: "From £325/pcm",
    shortDescription: "In the heart of popular Hackney Downs, tucked beside railway arches. A bustling creative community spread over two floors. Classic warehouse construction, one of our busiest complexes since 2012.",
    longDescription: "Part of a neighbourhood creative community along the arches. Studios range from 100–750sqft across two floors.",
    specification: ["Natural daylight", "Wi-Fi", "Entryphone system", "CCTV"],
    transport: {
      underground: [
        { name: "Seven Sisters Underground Station", detail: "1.2 miles (24 min walk)" },
        { name: "Tottenham Hale Underground Station", detail: "1.3 miles (26 min walk)" },
      ],
      mainline: [
        { name: "Rectory Road Station", detail: "0.9 miles (18 min walk)" },
        { name: "Lea Bridge Station", detail: "0.9 miles (18 min walk)" },
      ],
      amenities: [
        { name: "Hackney Downs Park", detail: "0.4 miles (8 min walk)" },
        { name: "The Pembury Tavern", detail: "0.6 miles (12 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/warwick-works-hero.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "3-5-latona-road",
    name: "3-5 Latona Road",
    area: "Peckham",
    address: "3-5 Latona Rd, London, SE15 6RX",
    isNew: false,
    capacity: "23 Studios",
    sizeRange: "100sqft – 900sqft",
    priceFrom: "From £350/pcm",
    shortDescription: "Located just off the Old Kent Road near Burgess Park. 26 studios over three floors, most with double height ceilings and south-facing natural light. One of our most popular locations.",
    longDescription: "A very active creative community: picture framers, Vogue cover photographers, shared design studios. Large goods lift to all floors.",
    specification: ["Natural daylight", "Elevator", "Entryphone system", "Wi-Fi", "CCTV", "Free street parking"],
    transport: {
      underground: [
        { name: "Peckham Rye Station", detail: "1.2 miles (24 min walk)" },
        { name: "Rotherhithe Station", detail: "1.0 mile (20 min walk)" },
      ],
      mainline: [
        { name: "Elephant & Castle Station", detail: "0.6 miles (12 min walk)" },
        { name: "Bermondsey Station", detail: "0.8 miles (16 min walk)" },
      ],
      amenities: [
        { name: "Burgess Park", detail: "0.5 miles (10 min walk)" },
        { name: "Peckham Pulse Leisure Centre", detail: "0.8 miles (16 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/3-5-latona-road-south-london-studio-spaces.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "7-17-latona-road",
    name: "7-17 Latona Road",
    area: "Peckham",
    address: "7-17 Latona Road, London, SE15 6RX",
    isNew: false,
    capacity: "10 Studios",
    sizeRange: "250sqft – 1,700sqft",
    priceFrom: "From £600/pcm",
    shortDescription: "Sharing its yard with 3-5 Latona, this building features huge glazed crittall windows and good natural light. Ground floor has five large units suited to photography, sculpture or product design.",
    longDescription: "Units benefit from own toilets and kitchens. First floor features a 1,700sqft daylight studio with balcony access, plus smaller studios and offices.",
    specification: ["Natural daylight", "Free street parking", "Wi-Fi", "CCTV", "Entryphone system"],
    transport: {
      underground: [
        { name: "Peckham Rye Station", detail: "1.2 miles (24 min walk)" },
        { name: "Rotherhithe Station", detail: "1.0 mile (20 min walk)" },
      ],
      mainline: [
        { name: "Elephant & Castle Station", detail: "0.6 miles (12 min walk)" },
        { name: "Bermondsey Station", detail: "0.8 miles (16 min walk)" },
      ],
      amenities: [
        { name: "Burgess Park", detail: "0.5 miles (10 min walk)" },
        { name: "Peckham Pulse Leisure Centre", detail: "0.8 miles (16 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/7-17-latona-road-hero.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "unit-10-juno-way",
    name: "Unit 10 (Juno Way)",
    area: "South Bermondsey",
    address: "Elizabeth Industrial Estate, Juno Way, London, SE14 5RW",
    isNew: false,
    capacity: "35 Studios",
    sizeRange: "72sqft – 1,800sqft",
    priceFrom: "From £265/pcm",
    shortDescription: "Always in high demand — spaces here get snapped up quick. Renovated in 2012/13, spread over three floors. Some split-level studios with mezzanine and kitchen. Heavy goods lift to all floors.",
    longDescription: "Ground floor has large roller shutter studios ideal for industrial practices or photography. Upper floors have sun-filled studios for artists or desk-based work.",
    specification: ["Central heating", "Natural daylight", "Elevator", "Wi-Fi", "Entryphone system", "CCTV", "Off street parking"],
    transport: {
      underground: [
        { name: "New Cross Gate Station", detail: "0.5 miles (10 min walk)" },
        { name: "Bermondsey Station", detail: "1.2 miles (24 min walk)" },
      ],
      mainline: [
        { name: "South Bermondsey Station", detail: "0.4 miles (8 min walk)" },
        { name: "Surrey Quays Station", detail: "0.6 miles (12 min walk)" },
      ],
      amenities: [
        { name: "Deptford Park", detail: "0.7 miles (14 min walk)" },
        { name: "The Den (Millwall FC)", detail: "0.9 miles (18 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/unit-10-hero.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "unit-13-elizabeth-tower",
    name: "Unit 13 (Elizabeth Tower)",
    area: "South Bermondsey",
    address: "Juno Way, London, SE14 5RW",
    isNew: false,
    capacity: "13 Studios",
    sizeRange: "50sqft – 2,400sqft",
    priceFrom: "From £150/pcm",
    shortDescription: "Renovated from a complete shell in 2011, this former tea factory has 12 self-contained studios. Topped with a copper clad tower. Great natural light and very high ceilings. No lift in this building.",
    longDescription: "Studios range from 50sqft to 2,400sqft with a range of configurations. Communal kitchen. Located in South Bermondsey with Deptford Park and Southwark Park within walking distance.",
    specification: ["Natural daylight", "High ceilings", "Wi-Fi", "Entryphone system", "CCTV", "Off street parking"],
    transport: {
      underground: [
        { name: "New Cross Gate Station", detail: "0.8 miles (16 min walk)" },
        { name: "Bermondsey Station", detail: "1.2 miles (24 min walk)" },
      ],
      mainline: [
        { name: "South Bermondsey Station", detail: "0.9 miles (18 min walk)" },
        { name: "Surrey Quays Station", detail: "1.1 miles (22 min walk)" },
      ],
      amenities: [
        { name: "Deptford Park", detail: "0.7 miles (14 min walk)" },
        { name: "The Den (Millwall FC)", detail: "0.9 miles (18 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/unit-13-hero.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "platform-studios-east",
    name: "Platform Studios (East)",
    area: "Hackney Central",
    address: "Morning Lane, London, E9 6LH",
    isNew: false,
    capacity: "29 Studios",
    sizeRange: "65sqft – 2,000sqft",
    priceFrom: "From £435/pcm",
    shortDescription: "Located in the heart of Hackney Central, Platform Studios (East) offers contemporary workspace with high ceilings and abundant natural light. Perfect for start-ups, freelancers, or established businesses.",
    longDescription: "A flexible and stylish environment that fosters collaboration and growth. Just a short walk from Hackney Central Overground, surrounded by an eclectic mix of markets, independent shops and buzzing nightlife.",
    specification: ["Excellent natural daylight", "Elevator", "High ceilings"],
    transport: {
      underground: [
        { name: "Bethnal Green Station", detail: "1.3 miles (26 min walk)" },
        { name: "Stratford Station", detail: "2.1 miles (42 min walk)" },
      ],
      mainline: [
        { name: "Hackney Central Station", detail: "0.3 miles (6 min walk)" },
        { name: "London Fields Station", detail: "0.5 miles (10 min walk)" },
      ],
      amenities: [
        { name: "London Fields Park", detail: "0.7 miles (14 min walk)" },
        { name: "Broadway Market", detail: "Artisan food, cafés and boutiques" },
      ],
    },
    heroImageUrl: `${BASE}/platform-studios-east-hero.webp`,
    galleryImageUrls: [],
  },
  {
    slug: "gransden-avenue",
    name: "Gransden Avenue",
    area: "London Fields",
    address: "39 Gransden Ave, London, E8 3QA",
    isNew: false,
    capacity: "19 Studios",
    sizeRange: "160sqft – 3,000sqft",
    priceFrom: "From £1,810/pcm",
    shortDescription: "Situated in the heart of London Fields, right around the corner from the park. Our most unique location with over fifteen units, some with direct street access spread over multiple floors.",
    longDescription: "Most units have personal entrances and benefit from a kitchenette and WC. The feel here is industrial featuring raw concrete, metal & glass. Just a short walk from London Fields station and Broadway Market.",
    specification: ["Natural daylight", "High-speed Wi-Fi", "Air conditioning", "24/7 access"],
    transport: {
      underground: [
        { name: "Bethnal Green Station", detail: "1.7 miles (34 min walk)" },
        { name: "Dalston Kingsland Station", detail: "0.7 miles (14 min walk)" },
      ],
      mainline: [
        { name: "London Fields Station", detail: "0.3 miles (6 min walk)" },
        { name: "Hackney Downs Station", detail: "0.5 miles (10 min walk)" },
      ],
      amenities: [
        { name: "London Fields Park", detail: "0.3 miles (6 min walk)" },
        { name: "Broadway Market", detail: "0.5 miles (10 min walk)" },
        { name: "The Hackney Empire", detail: "0.7 miles (14 min walk)" },
      ],
    },
    heroImageUrl: `${BASE}/gransden-avenue-hero.webp`,
    galleryImageUrls: [],
  },
];

export const featuredBuildingSlugs = [
  "goswell-road",
  "cannon-wharf",
  "the-mille",
  "platform-studios-west",
  // "oxgate-house",
  "wallis-house",
  "stone-studios",
  "paynes-wharf",
  "q-west",
];

export function getBuildingBySlug(slug) {
  return buildings.find((b) => b.slug === slug) || null;
}

export function getFeaturedBuildings() {
  return featuredBuildingSlugs.map((slug) => getBuildingBySlug(slug)).filter(Boolean);
}